module.exports = __webpack_public_path__ + "img/sl_r.02dffe08.jpg";